(() => {
  // ============ DOM REFS ============
  const stage1 = document.getElementById('stage1');
  const stage3 = document.getElementById('stage3');
  const stage4 = document.getElementById('stage4');
  const pctEl  = document.getElementById('pct');

  // ============ FUNCTION DEFINITIONS ============

  function buildSegBar() {
    const SEGS   = 16;
    const segBar = document.getElementById('seg-bar');
    for (let i = 0; i < SEGS; i++) {
      const s = document.createElement('div');
      s.className = 'seg';
      segBar.appendChild(s);
    }
    const segs = segBar.querySelectorAll('.seg');

    let pctStart = null;
    function pctTick(ts) {
      if (!pctStart) pctStart = ts;
      const p      = Math.min((ts - pctStart) / 5000, 1) * 100;
      const filled = Math.round(p / 100 * SEGS);
      pctEl.textContent = Math.floor(p) + '%';
      segs.forEach((s, i) => s.classList.toggle('on', i < filled));
      if (p < 100) requestAnimationFrame(pctTick);
    }
    requestAnimationFrame(pctTick);
  }

  function showEnter() {
    const enterHandler = () => {
      document.removeEventListener('click', enterHandler);
      document.removeEventListener('keydown', keyHandler);
      stage3.classList.remove('show');
      setTimeout(() => {
        stage4.classList.add('show');
        initGrid(false);
      }, 400);
    };
    const keyHandler = (e) => {
      if (e.key === 'Enter' || e.key === ' ') enterHandler();
    };
    document.addEventListener('click', enterHandler);
    document.addEventListener('keydown', keyHandler);
  }

  function initGrid(showSuccess) {
    const cv   = document.getElementById('grid'), ctx = cv.getContext('2d');
    const cur  = document.getElementById('cur');
    const cxEl = document.getElementById('cx'), cyEl = document.getElementById('cy');
    let W, H, DPR, CELL = 28, cols, rows, energy, noise;
    let mouse      = { x: -9999, y: -9999, active: false };
    let gridReveal = 1.0;
    let rafId      = null;
    let running    = true;

    function resize() {
      DPR       = Math.min(devicePixelRatio || 1, 2);
      W         = innerWidth; H = innerHeight;
      cv.width  = W * DPR; cv.height = H * DPR;
      ctx.setTransform(DPR, 0, 0, DPR, 0, 0);
      cols   = Math.ceil(W / CELL); rows = Math.ceil(H / CELL);
      energy = new Float32Array(cols * rows);
      noise  = new Float32Array(cols * rows);
      for (let i = 0; i < noise.length; i++) noise[i] = Math.random();
    }
    addEventListener('resize', resize);

    document.addEventListener('visibilitychange', () => {
      running = !document.hidden;
      if (running && !rafId) loop();
    });

    function paint(mx, my) {
      const cx = mx / CELL, cy = my / CELL, R = 2.7;
      const i0 = Math.max(0, (cx - R - 1) | 0), i1 = Math.min(cols - 1, (cx + R + 1) | 0);
      const j0 = Math.max(0, (cy - R - 1) | 0), j1 = Math.min(rows - 1, (cy + R + 1) | 0);
      for (let j = j0; j <= j1; j++) for (let i = i0; i <= i1; i++) {
        const d     = Math.hypot(i + .5 - cx, j + .5 - cy);
        const k     = i + j * cols;
        const reach = R * (.7 + .55 * noise[k]);
        if (d < reach) {
          const add = (1 - d / reach) * .9;
          if (add > energy[k]) energy[k] = Math.min(1, energy[k] + (add - energy[k]) * .6 + .2);
        }
      }
    }

    function drawGrid() {
      ctx.globalCompositeOperation = 'source-over';
      ctx.clearRect(0, 0, W, H);
      const TH = .5;
      ctx.font         = "500 10px 'Space Grotesk', sans-serif";
      ctx.textAlign    = 'center';
      ctx.textBaseline = 'middle';
      for (let j = 0; j < rows; j++) for (let i = 0; i < cols; i++) {
        const k = i + j * cols;
        const e = Math.max(energy[k], gridReveal * (0.5 + noise[k] * 0.5));
        const x = i * CELL, y = j * CELL;
        if (e < TH) {
          let tileA = 0.45;
          if (e > .32) tileA = tileA * (1 - (e - .32) / (TH - .32));
          ctx.fillStyle   = 'rgba(6,14,20,' + tileA + ')';
          ctx.fillRect(x, y, CELL, CELL);
          ctx.strokeStyle = 'rgba(193,204,198,' + (0.06 * (1 - e * 1.5)) + ')';
          ctx.lineWidth   = 1;
          ctx.strokeRect(x + .5, y + .5, CELL, CELL);
          let n = 0;
          for (let dy = -1; dy <= 1; dy++) for (let dx = -1; dx <= 1; dx++) {
            if (!dx && !dy) continue;
            const ni = i + dx, nj = j + dy;
            if (ni < 0 || nj < 0 || ni >= cols || nj >= rows) continue;
            const ne = Math.max(energy[ni + nj * cols], gridReveal * (0.5 + noise[ni + nj * cols] * 0.5));
            if (ne >= TH) n++;
          }
          if (n > 0 && tileA > .2 && noise[k] > .2) {
            ctx.fillStyle = 'rgba(193,204,198,' + (0.65 * (1 - e)) + ')';
            ctx.fillText(Math.min(n, 4), x + CELL / 2, y + CELL / 2 + 1);
          }
        }
      }
      ctx.globalAlpha = .03; ctx.fillStyle = '#000';
      for (let y = 0; y < H; y += 3) ctx.fillRect(0, y, W, 1);
      ctx.globalAlpha = 1;
    }

    function loop() {
      if (!running) { rafId = null; return; }
      for (let i = 0; i < energy.length; i++) if (energy[i] > 0) energy[i] = Math.max(0, energy[i] - 0.006);
      drawGrid();
      rafId = requestAnimationFrame(loop);
    }

    addEventListener('pointermove', e => {
      mouse.x = e.clientX; mouse.y = e.clientY; mouse.active = true;
      cur.style.left = e.clientX + 'px'; cur.style.top = e.clientY + 'px';
      cxEl.textContent = (e.clientX / innerWidth  * 100).toFixed(1).padStart(5, '0');
      cyEl.textContent = (e.clientY / innerHeight * 100).toFixed(1).padStart(5, '0');
      if (gridReveal < 0.3) paint(e.clientX, e.clientY);
    });
    addEventListener('pointerleave', () => mouse.active = false);

    document.querySelectorAll('a, button, input, .spin-mark').forEach(el => {
      el.addEventListener('pointerenter', () => cur.classList.add('big'));
      el.addEventListener('pointerleave', () => cur.classList.remove('big'));
    });

    // ============ EMAIL SIGNUP ============
    const signupForm = document.getElementById('torque-signup');
    const emailInput = document.getElementById('email');
    const msgEl      = document.getElementById('msg');
    const joinBtn    = document.getElementById('join');

    function showMsg(text, success) {
      msgEl.textContent   = text;
      msgEl.style.color   = success ? 'var(--sage)' : '#d97a7a';
      msgEl.style.opacity = '1';
    }

    // If we just came back from a successful submit, show success immediately
    if (showSuccess) {
      setTimeout(() => showMsg("You're on the list", true), 800);
    }

    signupForm.addEventListener('submit', (e) => {
      const val = emailInput.value.trim();
      if (!val || !val.includes('@')) {
        e.preventDefault();
        showMsg('Enter a valid email', false);
        return;
      }
      // Set flag BEFORE the page reloads so we catch it on return
      sessionStorage.setItem('torque_submitted', '1');
      joinBtn.disabled    = true;
      joinBtn.textContent = '…';
      // Let the form submit naturally — Shopify handles it, page reloads
    });

    resize();
    rafId = requestAnimationFrame(loop);

    setTimeout(() => {
      const startT   = performance.now();
      const duration = 1400;
      function animateGrid() {
        const elapsed = performance.now() - startT;
        const t       = Math.min(elapsed / duration, 1);
        gridReveal    = 1 - (1 - Math.pow(1 - t, 4));
        if (t < 1) requestAnimationFrame(animateGrid);
        else gridReveal = 0;
      }
      animateGrid();
    }, 1000);
  }

  // ============ BOOT — check sessionStorage first ============
  const justSubmitted = sessionStorage.getItem('torque_submitted');

  if (justSubmitted) {
    // User just signed up — skip all loading screens, go straight to stage 4
    sessionStorage.removeItem('torque_submitted');
    stage1.classList.add('gone');
    stage4.classList.add('show');
    initGrid(true); // true = show success message
  } else {
    // Normal first visit — run the full loading sequence
    buildSegBar();
    setTimeout(() => {
      stage1.classList.add('gone');
      stage3.classList.add('show');
    }, 5000);
    showEnter();
  }

})();